export const dropzonePreviewTemplate = () => `
<div class="dz-preview">
    <div class="dz-details">
        <div class="dz-size"><span data-dz-size></span></div>
        <div class="dz-filename"><span data-dz-name></span></div>
    </div>
</div>
`
